<template>
  <div id="app">
    <Loading v-if="hasUnhandledCalls || viewPending" />
    <AlertModal
      :show-modal="hasAlert"
      :alert="getCurrentAlert"
      size="md"/>
    <router-view :key="$route.fullPath"/>
    <SideMenu
      v-if="showSideMenu"
      @close="$store.commit('menu/showSideMenu', false)"/>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapGetters } from 'vuex';
import AlertModal from '@/components/Modal/AlertModal';
import Loading from '@/components/Utils/Loading';
import SideMenu from '@/components/Menu/SideMenu';

export default {
  name: 'App',
  components: {
    AlertModal,
    Loading,
    SideMenu,
  },
  computed: {
    ...mapGetters('loading', ['hasUnhandledCalls']),
    ...mapState('loading', ['viewPending']),
    ...mapState('member', ['selectedMember']),
    ...mapState('user', ['isLoggedIn']),
    ...mapState('menu', ['showSideMenu']),
    ...mapGetters('alerts', ['hasAlert', 'getCurrentAlert']),
  },
  watch: {
    selectedMember: {
      handler(newVal) {
        if (newVal && newVal.language) {
          this.$i18n.locale = newVal.language;
          moment.locale(`${newVal.language}_CA`);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" src="./styles/main.scss" />
